import { Modal } from "antd"
import React from "react"
import CircleIcon from "./CircleIcon"
import GenericButton from "./GenericButton"

export default function GenericModal({ closeIcon = <CircleIcon iconUrl={"common/Iconionic-md-close-circle-outline"} />, component2, ...props }) {
  return (
    <>
      <Modal
        centered
        open={props.visibleState}
        footer={null}
        onCancel={() => props.updateVisibility()}
        className={props.rootClassAntCustom}
        wrapClassName={props.wrapClassName}
        closable={props.closeIconVisible}
        closeIcon={closeIcon}
        zIndex={props.zIndex}
        maskStyle={{
          backgroundColor: "#141414E6",
        }}
      >
        {props.component}
        {props.showButton ? (
          <GenericButton title={props.buttonText} buttonStyle={props.buttonStyle} onClick={() => props.buttononClick()} className={props.buttonWrapper} shape={props.buttonShape} />
        ) : (
          ""
        )}
        {component2 && component2}
      </Modal>
    </>
  )
}
